export default __webpack_public_path__ + "static/media/زمان.8812ea38.svg";